export default __webpack_public_path__ + "static/media/logo.2e7d62e7.png";